import type { ImageMetrics, OriginalDimensions } from '../useImageMetrics'

/**
 * 画像メトリクスを取得する共通ユーティリティ
 * コンテナサイズベースで計算されたmetricsをそのまま使用
 */
export const getImageMetrics = (
  getMetrics: () => ImageMetrics,
  originalDimensions: OriginalDimensions | null,
) => {
  if (!originalDimensions) return null
  const metrics = getMetrics()
  const { dispW, dispH, offX, offY, containerW, containerH } = metrics
  if (dispW === 0 || dispH === 0 || containerW === 0 || containerH === 0) {
    return null
  }

  return {
    dispW,
    dispH,
    offX,
    offY,
    containerW,
    containerH,
  }
}
